// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bottom-border[data-v-5d436c04]{border-bottom:1px solid #ccc}a[data-v-5d436c04]{color:#454545;-webkit-transition:color .2s ease-in-out;transition:color .2s ease-in-out}a[data-v-5d436c04]:hover{color:#0f0f0f}", ""]);
// Exports
module.exports = exports;
